import axios from './axios';

/**
 * API Utility for Client Management Portal
 * Handles JWT tokens for BitNetOrgAdmin and ClientOwner auth
 */

// Main API call function
export const apiCall = async (endpoint, method = 'GET', data = null, config = {}) => {
  try {
    const response = await axios({
      url: endpoint,
      method,
      data,
      ...config,
    });

    return response.data;
  } catch (error) {
    console.error('API Error:', error);

    const errorMessage = error.response?.data?.message ||
                        error.response?.data?.error ||
                        error.message ||
                        'An error occurred';

    throw new Error(errorMessage);
  }
};

// Get user info from JWT token
export const getUserFromToken = () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) return null;

    // Decode JWT payload (base64)
    const payload = JSON.parse(atob(token.split('.')[1]));
    return {
      userId: payload.userId,
      companyName: payload.companyName,
      email: payload.email,
      name: payload.name,
      role: payload.role,
      isOrgAdmin: payload.role === 'BitNetOrgAdmin',
      isClientOwner: payload.isClientOwner || false
    };
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};

// Check if user is authenticated (token exists and not expired)
export const isAuthenticated = () => {
  const token = localStorage.getItem('token');
  if (!token) return false;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Date.now() / 1000;

    if (payload.exp < currentTime) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      return false;
    }

    return true;
  } catch (error) {
    console.error('Error checking authentication:', error);
    return false;
  }
};

// Authentication API functions for CM portal
export const authAPI = {
  // OTP login (BitNetOrgAdmin)
  sendOtp: (email) => {
    return apiCall('/api/auth/send-otp', 'POST', { email });
  },

  verifyOtp: (email, otp) => {
    return apiCall('/api/auth/verify-otp', 'POST', { email, otp });
  },

  // Client Owner login
  login: (credentials) => {
    return apiCall('/api/auth/login', 'POST', credentials);
  },

  // Get current user profile
  getMe: () => {
    return apiCall('/api/auth/me');
  },

  // Logout
  logout: () => {
    return apiCall('/api/auth/logout', 'POST');
  },

  // Force reset password
  forceResetPassword: (data) => {
    return apiCall('/api/auth/force-reset-password', 'POST', data);
  },

  // Change owner password
  changeOwnerPassword: (data) => {
    return apiCall('/api/auth/change-owner-password', 'POST', data);
  }
};

export default axios;
